// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5b864b16","376":"0c40a5e1","453":"b28e8280","551":"c76700e5","617":"1b5543e7","640":"b544f80a","842":"56b323a3","851":"716286bf","950":"d4c5024e"}[chunkId] + ".chunk.js";
};